<template>
  <div class="dialog-body">
    <el-dialog
      v-if="dialogVisible"
      title="仓单冻结状态提示"
      align="center"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      ref="dialogRef"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              >仓单为冻结状态，不能进行任何操作，请先解冻</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确认</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'FrezeDialog',
    props: ['id'],
    data() {
      return {
        dialogVisible: false,
      };
    },
    methods: {
      // 打开弹窗
      openDialog() {
        this.dialogVisible = true;
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
      },
      // 确认
      handleSure() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .el-select {
    width: 320px;
  }
  .el-form {
    margin-top: 15px;
  }
  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
